import { render, staticRenderFns } from "./LeadDetails.vue?vue&type=template&id=3a0fa3c8&scoped=true&"
import script from "./LeadDetails.vue?vue&type=script&lang=js&"
export * from "./LeadDetails.vue?vue&type=script&lang=js&"
import style0 from "./LeadDetails.vue?vue&type=style&index=0&id=3a0fa3c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0fa3c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VDivider,VIcon,VList,VListItem,VListItemTitle,VMenu,VSpacer})
